// extracted by mini-css-extract-plugin
export default {"halted-label":"HaltedLabel_halted-label__Yb3z2","cancel-mode":"HaltedLabel_cancel-mode__8FLUw","auction-time":"HaltedLabel_auction-time__blEG6"};